import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { FormModalComponent } from "../form-modal-component.class";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { NgTemplateOutlet } from "@angular/common";
import { ArticleTemplate } from "../../../../_models";
import { MatFormField } from "@angular/material/form-field";
import { MatOption } from "@angular/material/core";
import { MatSelect } from "@angular/material/select";
import {
  CreateMaterialRequirementAttributes,
  MaterialRequirement,
} from "../../../../_models/material-requirement.interface";
import { MaterialRequirementService } from "../../../../_services/material-article.service";

@Component({
  selector: "hawk-add-new-material-requirement-modal",
  imports: [NgTemplateOutlet, ReactiveFormsModule, FormsModule, MatFormField, MatOption, MatSelect],
  templateUrl: "./add-new-material-requirement-modal.component.html",
  styleUrl: "./add-new-material-requirement-modal.component.scss",
})
export class AddNewMaterialRequirementModalComponent
  extends FormModalComponent<CreateMaterialRequirementAttributes, MaterialRequirement>
  implements OnChanges
{
  @Input() articleTemplates: ArticleTemplate[] = [];

  @Input() override formGroup: UntypedFormGroup;
  @Output() override closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() override newDBOutput: EventEmitter<MaterialRequirement> = new EventEmitter<MaterialRequirement>();

  selectedTemplateFilter: string = "all";
  templateSearchText: string = "";

  filteredTemplates: ArticleTemplate[] = [];

  constructor(private materialRequirementService: MaterialRequirementService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateFilteredTemplates();
  }

  override formGroupToDBInput(): CreateMaterialRequirementAttributes {
    const controls = this.formGroup.controls;
    return {
      amount: controls["amount"].value,
      article_template_id: controls["article_template_id"].value,
      project_id: controls["project_id"].value,
    };
  }

  override getDBCallObservable(
    material_requirement: CreateMaterialRequirementAttributes,
  ): Observable<MaterialRequirement> {
    return this.materialRequirementService.createMaterialRequirement(material_requirement);
  }

  updateFilteredTemplates() {
    this.filteredTemplates = this.articleTemplates.filter((at) => {
      if (!at.description.toLowerCase().includes(this.templateSearchText.toLowerCase())) return false;

      if (!this.selectedTemplateFilter || this.selectedTemplateFilter == "all") return true;
      if (!at.comment2) return this.selectedTemplateFilter == "inclusive_project";

      const possible_project_ids = at.comment2.split(",");
      const parsed_ids = possible_project_ids.map((possible_id) => Number.parseInt(possible_id));
      if (parsed_ids.every((parsed_id) => Number.isInteger(parsed_id))) {
        return parsed_ids.includes(this.formGroup.controls["project_id"].value);
      } else {
        return false;
      }
    });
  }
}
